const config = {
  cognito: {
    USER_POOL_ID: 'us-east-1_HAudl9mhg',
    APP_CLIENT_ID: '3d33c2jh1gjflngd1f27pvf9n',
    REGION: 'us-east-1',
    SSO_APP_CLIENT_ID: '4tvouvn0ivr3rq3dj25ps6o58f',
    IDP_DOMAIN: 'dragonflyadvise',
    IDP_REDIRECT_URL: window.location.hostname.includes('dragonfly') ? 'https://dragonflyadvise.xsolis.ai/sso' : 'https://xpas.xsolis.com/sso',
    TOKEN_ENDPOINT: 'https://dragonflyadvise.auth.us-east-1.amazoncognito.com/oauth2/token'
  },
  SERVICES: {
    V2: 'eb10v9qupi.execute-api.us-east-1.amazonaws.com'
   },
   HOST: '30qchqv5j3.execute-api.us-east-1.amazonaws.com',
   ENV: 'prod',
   TIMEOUT: 7200000,
   REPORTING_URL: 'https://dragonflyreporting.xsolis.ai/'
}

config.cognito.HOSTED_SIGN_IN_URL = `https://${config.cognito.IDP_DOMAIN}.auth.us-east-1.amazoncognito.com/login?client_id=${config.cognito.SSO_APP_CLIENT_ID}&redirect_uri=${config.cognito.IDP_REDIRECT_URL}&response_type=code&state=STATE`

export default config